import { render, staticRenderFns } from "./save-search.vue?vue&type=template&id=c2126784&"
import script from "./save-search.vue?vue&type=script&lang=js&"
export * from "./save-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports